/* Minha Kidz product media gallery: direct Shopify variant IDs and image/colour fallback. */
(() => {
  'use strict';
  const get=(sel,base=document)=>base.querySelector(sel);
  const all=(sel,base=document)=>Array.from(base.querySelectorAll(sel));
  const norm=s=>String(s||'').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim().replace(/\s+/g,' ');
  function imagePath(url){
    try{
      const u=new URL(url,location.href);
      return decodeURIComponent(u.pathname).toLowerCase().replace(/_(?:\d+x\d*|\d*x\d+|\d+x|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.[^.]+$)/,'');
    }catch(_){return '';}
  }
  function colorInText(text, color) {
    const c=norm(color), t=norm(text);
    if(!c||!t) return false;
    // Do not match 'tan' against 'standing' or 'red' against 'border'.
    return (' '+t+' ').includes(' '+c+' ');
  }
  function init(gallery) {
    if (gallery.dataset.mkGalleryReady) return;
    gallery.dataset.mkGalleryReady='true';
    const slides=all('[data-mk-gallery-slide]',gallery);
    const thumbs=all('[data-mk-gallery-thumb]',gallery);
    const stage=get('.mk-product-gallery__stage',gallery);
    const counter=get('[data-mk-gallery-counter]',gallery);
    if(!stage||!slides.length) return;
    let active=0;
    const mod=value=>((value % slides.length)+slides.length)%slides.length;
    function display(index,focusThumb=false){
      const next=mod(index);
      slides.forEach((slide,i)=>{
        const selected=i===next;
        if(!selected){
          slide.querySelectorAll('video').forEach(v=>{if(!v.paused)v.pause();});
          slide.querySelectorAll('model-viewer').forEach(v=>{if(typeof v.pause==='function')v.pause();});
        }
        slide.hidden=!selected;
        slide.setAttribute('aria-hidden',String(!selected));
      });
      thumbs.forEach((thumb,i)=>{
        const selected=i===next;
        thumb.classList.toggle('is-active',selected);
        thumb.setAttribute('aria-pressed',String(selected));
        if(selected){
          const rail=thumb.parentElement;
          if(rail){
            const left=thumb.offsetLeft-rail.offsetLeft;
            if(left<rail.scrollLeft)rail.scrollLeft=left;
            else if(left+thumb.offsetWidth>rail.scrollLeft+rail.clientWidth)rail.scrollLeft=left+thumb.offsetWidth-rail.clientWidth;
          }
          if(focusThumb)thumb.focus({preventScroll:true});
        }
      });
      active=next;
      if(counter)counter.textContent=`${active+1} / ${slides.length}`;
    }
    get('[data-mk-gallery-prev]',gallery)?.addEventListener('click',()=>display(active-1));
    get('[data-mk-gallery-next]',gallery)?.addEventListener('click',()=>display(active+1));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>display(i)));
    gallery.addEventListener('keydown',event=>{
      if(event.target.matches('input, textarea, select, video, model-viewer'))return;
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
        event.preventDefault();
        display(active+(event.key==='ArrowRight'?1:-1),thumbs.includes(document.activeElement));
      }
    });
    let touchStart=null;
    stage.addEventListener('touchstart',e=>{
      if(e.touches.length===1)touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};
    },{passive:true});
    stage.addEventListener('touchend',e=>{
      if(!touchStart||!e.changedTouches.length)return;
      const dx=e.changedTouches[0].clientX-touchStart.x;
      const dy=e.changedTouches[0].clientY-touchStart.y;
      touchStart=null;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.25)display(active+(dx<0?1:-1));
    },{passive:true});

    const form=gallery.closest('.product-editorial')?.querySelector('[data-product-form]');
    const variantSelect=form?.querySelector('[data-variant-select]');
    const variantJson=form?.querySelector('[data-mk-product-variants]');
    const mediaMapJson=get('[data-mk-variant-media-map]',gallery);
    let variantMedia={},variants=[];
    try{variantMedia=JSON.parse(mediaMapJson?.textContent||'{}');}catch(_){variantMedia={}}
    try{variants=JSON.parse(variantJson?.textContent||'[]');}catch(_){variants=[]}
    const colorGroup=all('[data-mk-option-group]',form||gallery).find(g=>/colou?r|shade/i.test(g.querySelector('legend')?.textContent||''));
    const colorIndex=colorGroup?Number(colorGroup.dataset.mkOptionIndex):-1;
    function findImage(variant){
      const mapped=variantMedia[String(variant.id)]||{};
      // Preferred: Shopify Admin > Product > Variants > assign each variant its image.
      const mediaId=variant.featured_media?.id||mapped.media;
      if(mediaId){
        const i=slides.findIndex(s=>String(s.dataset.productMediaId)===String(mediaId));
        if(i>=0)return i;
      }
      const imageId=variant.featured_image?.id||mapped.image;
      if(imageId){
        const i=slides.findIndex(s=>String(s.dataset.productMediaImageId)===String(imageId));
        if(i>=0)return i;
      }
      const src=variant.featured_image?.src||mapped.src;
      if(src){
        const target=imagePath(src);
        const i=slides.findIndex(s=>{
          const img=get('img',s);
          const sources=[s.dataset.mkMediaSrc,img?.currentSrc,img?.src].filter(Boolean);
          return sources.some(u=>imagePath(u)===target);
        });
        if(i>=0)return i;
      }
      // Secondary: image Alt Text: 'Color: Mint Green' (or the colour anywhere in Alt).
      // Also reads a meaningful image filename, e.g. cardigan-mint-green-front.jpg.
      const color=(colorIndex>=0?(variant.options||[])[colorIndex]:null)||mapped.color||'';
      if(!color)return -1;
      const i=slides.findIndex(s=>{
        const img=get('img',s);
        return colorInText(s.dataset.mkMediaAlt || '',color);
      });
      if(i>=0)return i;
      return slides.findIndex(s=>{
        const img=get('img',s);
        const raw=[s.dataset.mkMediaSrc,img?.src].filter(Boolean).map(s=>{
          try{return decodeURIComponent(new URL(s,location.href).pathname.split('/').pop()||'')}catch(_){return ''}
        }).join(' ');
        return colorInText(raw,color);
      });
    }
    function changeToVariant(){
      if(!variantSelect)return;
      const variant=variants.find(v=>String(v.id)===String(variantSelect.value));
      if(!variant)return;
      const next=findImage(variant);
      if(next>=0)display(next);
    }
    if(variantSelect){
      variantSelect.addEventListener('change',changeToVariant);
      // Initial deep-linked variant also needs correct image on page load.
      changeToVariant();
    }
    else display(0);
  }
  function boot(root=document){
    if(root.matches?.('[data-mk-product-gallery]'))init(root);
    root.querySelectorAll?.('[data-mk-product-gallery]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
